import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

export default function EditToggler(props) {
  const { canRenderEdit, onRedirectToPreferences } = props;
  return canRenderEdit ? (
    <Button
      onClick={onRedirectToPreferences}
      buttonConfig={{ type: 'link', size: 'xs', label: 'Edit preferences', color: 'blue', e2eName: 'edit-preferences' }}
    />
  ) : null;
}

EditToggler.propTypes = {
  onRedirectToPreferences: PropTypes.func.isRequired,
  canRenderEdit: PropTypes.bool,
};
